import { FolderOpen } from 'lucide-react'
import { Card } from './ui'

function GoogleDriveEmbed({ folderId, folderName, height = '400px' }) {
  const embedUrl = `https://drive.google.com/embeddedfolderview?id=${folderId}#list`

  return (
    <Card noPadding className="overflow-hidden">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-neutral-200 bg-neutral-50">
        <FolderOpen className="w-5 h-5 text-primary-600" />
        <div>
          <h3 className="font-semibold text-neutral-800">Shared Files</h3>
          {folderName && <p className="text-sm text-neutral-500">{folderName}</p>}
        </div>
      </div>
      <iframe
        src={embedUrl}
        style={{ width: '100%', height, border: 'none' }}
        title="Google Drive Files"
      />
    </Card>
  )
}

export default GoogleDriveEmbed
